import React from 'react';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import PText from './PText';
import myLogo from '../assets/images/final_logo.webp';

const FooterStyle = styled.div`
  background-color: var(--deep-dark);
  padding-top: 10rem;
  .container {
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    max-width: 100%; /* Set maximum width for the image */
    height: auto;
  }
  .quote_line {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .quote_line {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <FooterStyle>
      <div className="container">
        <div className="footer__col1">
          <a href="/">
            <img src={myLogo} alt="Logo" className="footer__col1__title" />
          </a>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Important Links"
            links={[
              {
                title: 'Home',
                path: '/',
                type: 'Link',
              },
              {
                type: 'Link',
                title: 'About',
                path: '/about',
              },
              {
                type: 'Link',
                title: 'Projects',
                path: '/projects',
              },
              {
                type: 'Link',
                title: 'Contact',
                path: '/contact',
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Contact Info"
            links={[
              {
                title: '+1(503)619-6747',
                path: 'tel:+1(503)619-6747',
              },
              {
                title: 'nandisoham21@gmail.com',
                path: 'mailto:nandisoham21@gmail.com',
              },
              {
                title: 'Portland, USA',
                path: 'https://maps.app.goo.gl/joPW5BtKg3mBdQcQ7',
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="Social Links"
            links={[
              {
                title: 'LinkedIn',
                path: 'https://www.linkedin.com/in/nandisoham/',
              },
              {
                title: 'Github',
                path: 'https://github.com/NandiSoham',
              },
              {
                title: 'Leetcode',
                path: 'https://leetcode.com/u/valar_morghulis_21/',
              },
              {
                title: 'Instagram',
                path: 'https://www.instagram.com/valar_morghulis_21/',
              },
            ]}
          />
        </div>
      </div>
      <div className="quote_line">
        <div className="container">
          <PText>Be Kind, Spread Love❤️ | Keep Coding 👨🏻‍💻</PText>
        </div>
      </div>
    </FooterStyle>
  );
}
